module.exports = __webpack_public_path__ + "media/images/web_dev_180x180-0dd6ba8ce5eeb7f0ba8ee559e0566d68.png";